import * as plugins from './plugins.js';
import type {} from './interfaces.js';

/** The shared syntax configuration for parsing and HTML conversion. */
export const createMarkdownProcessor = () =>
  plugins.unified()
    .use(plugins.remarkParse)
    .use(plugins.remarkGfm)
    .use(plugins.remarkFrontmatter, ['yaml', 'toml']);

export type TMarkdownRoot = plugins.Root;
export type TMarkdownNode = plugins.Nodes;
export type TMarkdownRootContent = plugins.RootContent;
export type TMarkdownPhrasingContent = plugins.PhrasingContent;

/** Parse CommonMark, GFM and frontmatter without rendering HTML or performing I/O. */
export const parseMarkdown = (sourceArg: string): TMarkdownRoot => {
  if (typeof sourceArg !== 'string') {
    throw new TypeError('Markdown source must be a string.');
  }
  return createMarkdownProcessor().parse(sourceArg);
};
